module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.videourl) ? _c('div', {
    staticClass: "ideas"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "ideas-box"
  }, [_c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ideas-video-box"
  }, [(_vm.videourl) ? _c('div', {
    staticClass: "video-content"
  }, [_c('iframe', {
    attrs: {
      "src": _vm.parseUrl(_vm.videourl)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "video-desc"
  }, [_c('div', {
    staticClass: "video-title"
  }, [_vm._v(_vm._s(_vm.videotitle))]), _vm._v(" "), _c('div', {
    staticClass: "video-text",
    domProps: {
      "innerHTML": _vm._s(_vm.videotext)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "butterfly"
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d2a0d72","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlockHomeIdeas.vue
// module id = 311
// module chunks = 0